import { render } from "./PrintFooterDesign2.vue?vue&type=template&id=09efbf7a&scoped=true"
import script from "./PrintFooterDesign2.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign2.vue?vue&type=script&lang=js"

import "./PrintFooterDesign2.vue?vue&type=style&index=0&id=09efbf7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09efbf7a"]])

export default __exports__